import React, { Component, Fragment } from 'react';
import CountUp from 'react-countup';

import './style.scss';

export default class KeyFacts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: null,
            data: require('./data.json'),
        };
    }
    handleSelected(key) {
        this.setState({
            selected: key,
        });
    }
    render() {
        const { data } = this.state;
        return (
            <ul className="keyfacts-page">
                {data.items.map((item, key) => (
                    <li key={key} className={item.type}>
                        {item.type === 'number' ? (
                            <Fragment key={key}>
                                <h1>
                                    {item.start}
                                    <CountUp
                                        start={parseInt(item.number - 3)}
                                        end={parseInt(item.number)}
                                        decimal={item.decimal ? '.' : null}
                                        decimals={item.decimal ? 1 : 0}
                                    />
                                    {item.end === 'million' ? (
                                        <span className="small">{item.end}</span>
                                    ) : (
                                        item.end
                                    )}
                                </h1>
                                <p>{item.tagline}</p>
                            </Fragment>
                        ) : null}
                        {item.type === 'bar' ? (
                            <Fragment key={key}>
                                <div>
                                    <h2>{item.title}</h2>
                                    <img
                                        alt={item.title}
                                        className="iefix"
                                        src={
                                            'https://files.jdplc.com/images/iefix/' +
                                            item.ieSub +
                                            '.png'
                                        }
                                    />
                                    {item.ieSub === 'total_dividend' && (
                                        <div>
                                            *Final dividend withheld in light of COVID-19 – dividend
                                            payments to resume when conditions allow
                                        </div>
                                    )}
                                </div>
                            </Fragment>
                        ) : null}
                        {item.type === 'pie' ? (
                            <Fragment key={key}>
                                <div>
                                    <h2>{item.title}</h2>
                                    <img
                                        alt={item.title}
                                        className="iefix"
                                        src={
                                            'https://files.jdplc.com/images/iefix/' +
                                            item.ieSub +
                                            '.png'
                                        }
                                    />
                                </div>
                            </Fragment>
                        ) : null}
                    </li>
                ))}
            </ul>
        );
    }
}
